import { render } from "./IncomingGoodsClientModal.vue?vue&type=template&id=b856af78"
import script from "./IncomingGoodsClientModal.vue?vue&type=script&lang=js"
export * from "./IncomingGoodsClientModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__